import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../AxiosInstance/axiosInstance";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createCategoryData = createAsyncThunk(
  "categoryData/createSurname",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/v1/admin/categoryData/create-categoryData",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 300000, // 5 minutes timeout
          maxBodyLength: 50 * 1024 * 1024, // 50MB
          maxContentLength: 50 * 1024 * 1024, // 50MB
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCategoryData = createAsyncThunk(
  "categoryData/getAll",
  async (
    {
      categoryId,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/categoryData/get-categoryData`,
        {
          params: {
            categoryId,
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteCategoryData = createAsyncThunk(
  "categoryData/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.put(
        `/v1/admin/categoryData/delete-categoryData/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteCategoryData = createAsyncThunk(
  "categoryData/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.put(
        `/v1/admin/categoryData/undodelete-categoryData/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getCategoryByIdData = createAsyncThunk(
  "categoryData/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/categoryData/getSingle-categoryData/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateCategoryData = createAsyncThunk(
  "categoryData/update",
  async ({ _id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/categoryData/update-categoryData/${_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          maxBodyLength: 50 * 1024 * 1024,
          maxContentLength: 50 * 1024 * 1024,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getActiveCategoryData = createAsyncThunk(
  "ActiveCategoryData/getAll",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/categoryData/get-activecategoryData`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateCategoryOrder = createAsyncThunk(
  "categoryData/updateOrder",
  async (updatedCategory, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        "/v1/admin/category/set_orderwise",
        { categories: updatedCategory }
      );

      // Return the updated data in consistent format
      return updatedCategory;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
